import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useQuotes } from "@/components/Quotes";
import { num, pct } from "@/lib/format";

const Col = ({ group, title, prefix, pick }) => {
  const { data } = useQuotes(group);
  const items = (data?.items || []).slice(0, pick);
  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-5">
      <p className="font-display font-bold">{title}</p>
      <div className="mt-3 divide-y divide-slate-100">
        {items.length === 0 && <p className="text-sm text-slate-400 py-3">Loading…</p>}
        {items.map((q) => (
          <div key={q.symbol} className="flex justify-between items-baseline py-2.5 text-sm">
            <span className="font-semibold text-slate-700 truncate pr-2">{q.label}</span>
            <span className="font-mono text-right shrink-0">{prefix}{num(q.price, 2)} <span className={q.change_pct >= 0 ? "text-emerald-600" : "text-red-500"}>{pct(q.change_pct)}</span></span>
          </div>
        ))}
      </div>
    </div>
  );
};

export const MarketsBand = () => (
  <section data-testid="home-markets" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
    <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
      <div>
        <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#059669]">Forex · Commodities · Crypto</p>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight mt-2">Rupee, gold & crypto — live</h2>
      </div>
      <Link to="/markets" data-testid="home-markets-view" className="inline-flex items-center gap-1.5 text-sm font-bold text-[#059669]">Open markets <ArrowRight className="w-4 h-4" /></Link>
    </div>
    <div className="grid md:grid-cols-3 gap-5">
      <Col group="forex" title="Forex (₹)" prefix="₹" pick={5} />
      <Col group="commodities" title="Commodities (USD)" prefix="$" pick={5} />
      <Col group="crypto" title="Crypto (₹)" prefix="₹" pick={5} />
    </div>
  </section>
);
